import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { WheretoShopResponse } from './zeropay_where_to_shop';

@Injectable({ providedIn: 'root' })
export class ZeroPayAPI {
  constructor(private httpClient: HttpClient) {}

  private _host = environment.zeropay.host;
  private _key = environment.zeropay.accessKey;

  public async whereToShop(): Promise<WheretoShopResponse> {
    return await this.httpClient
      .get<WheretoShopResponse>(`${this._host}/v1/where-to-shop`, {
        headers: new HttpHeaders().append('X-Api-Key', this._key),
      })
      .toPromise();
  }

  public async whereToShopClick(placementId: string): Promise<void> {
    await this.httpClient
      .post<WheretoShopResponse>(
        `${this._host}/v1/where-to-shop`,
        {
          placementId,
          sourceId: environment.zeropay.sourceId,
          customerId: '',
        },
        {
          headers: new HttpHeaders().append('X-Api-Key', this._key),
        }
      )
      .toPromise();
  }
}
